import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY must be set for authentication to work.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    storageKey: 'playfunia_auth',
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
});
